<template>
  <v-dialog v-model="visible" max-width="445" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span v-if="curToken.enabled" class="v-dialog--custom__title">{{ $t(`${namespace}.titleDisable`) }}</span>
        <span v-else class="v-dialog--custom__title">{{ $t(`${namespace}.titleEnable`) }}</span>
        <v-btn class="v-dialog--custom__close mr-2" color="gray-6" flat fab @click.native="close(null)">
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-4 pt-0 pb-5">
        {{ curToken.token_value }}
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <a href="#" class="text--normal accent--text mr-4" color="accent" flat round @click.prevent="close(null)">
          {{ $t(`${namespace}.cancel`) }}
        </a>
        <v-btn color="accent" depressed round @click.prevent="handleSubmit">
          {{ $t(`${namespace}.submit`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import companyService from '@/services/company'
export default {
  name: 'UpdateTokenDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    curToken: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      namespace: 'Components.AllowApiToken.updateTokenDialog'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close (reload = null) {
      this.$emit('close')
    },

    async handleSubmit () {
      try {
        await companyService.updateToken({ tokenId: this.curToken.token_id, enabled: !this.curToken.enabled })
        this.showAlert({ type: 'success', message: this.$t(`Components.AllowApiToken.success`) })
        this.$emit('handleSubmit')
      } catch (e) {
        this.showAlert({ type: 'error', message: e.errmsg || this.$t(`Components.AllowApiToken.error`) })
      } finally {
        this.$emit('close')
      }
    }
  }
}
</script>
